import React from 'react'
import { useAppInsightsContext, useTrackEvent } from '@microsoft/applicationinsights-react-js'
import { eventTypes } from './eventTypes'

const AnalyticsWrapper = (props: any) => {
  const appInsights = useAppInsightsContext()
  const trackButtonClick = useTrackEvent(appInsights, eventTypes.button_clicked, {})

  const onClickWithAnalytics = async () => {
    const key = props?.keyAnalytics
    const text =
      typeof props.children?.props?.children === 'string'
        ? props.children?.props?.children
        : "can't get text"
    await trackButtonClick({ key, text })
    const { onClick } = props?.children?.props
    onClick()
  }

  return (
    <props.children.type
      {...props?.children?.props}
      onClick={onClickWithAnalytics}
    ></props.children.type>
  )
}

export default AnalyticsWrapper
